var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33333 9.99992C8.33333 9.07944 9.07952 8.33325 10 8.33325C10.9205 8.33325 11.6667 9.07944 11.6667 9.99992C11.6667 10.9204 10.9205 11.6666 10 11.6666C9.07952 11.6666 8.33333 10.9204 8.33333 9.99992Z",
    fill: "#94A3B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 9.99992C14.1667 9.07944 14.9129 8.33325 15.8333 8.33325C16.7538 8.33325 17.5 9.07944 17.5 9.99992C17.5 10.9204 16.7538 11.6666 15.8333 11.6666C14.9129 11.6666 14.1667 10.9204 14.1667 9.99992Z",
    fill: "#94A3B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 9.99992C2.5 9.07944 3.24619 8.33325 4.16667 8.33325C5.08714 8.33325 5.83333 9.07944 5.83333 9.99992C5.83333 10.9204 5.08714 11.6666 4.16667 11.6666C3.24619 11.6666 2.5 10.9204 2.5 9.99992Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.d44a6cc47844f6cb06eded215a3ae1c1.svg";
export { ForwardRef as ReactComponent };